import React from 'react';
import Landing from './components/views/Landing';

const App: React.FC = () => <Landing />;

export default App;
